export default () => ({
  page: null,
  errorState: [],
  formPosted: false,
  init() {
    this.page = window.location.pathname;
  },
  checkErrorState(errorState) {
    if ([...this.errorState].includes(errorState)) {
      return true;
    }
    return false;
  },

  submitRegisterForm(currentUrl) {
    let fetchUrl = "/account";
    const marketHandle = `/${Shopify.locale}-${Shopify.country.toLowerCase()}`;
    if (window.location.pathname.includes(marketHandle)) {
      fetchUrl = `${marketHandle}/account`;
    }
    const form = document.getElementById("customer_register");
    const email = document.getElementById("Email");
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const password = document.getElementById("Password");
    const confirmPassword = document.getElementById("PasswordConfirmation");
    this.errorState = [];

    if (!emailRegex.test(email.value)) {
      this.errorState.push("email_invalid");
      return;
    }

    if (password.value.length < 8) {
      this.errorState.push("password_length");
      return;
    } else if (confirmPassword.value === "") {
      this.errorState.push("password_confirm");
      return;
    } else if (password.value !== confirmPassword.value) {
      this.errorState.push("password_match");
      return;
    }

    const formData = new FormData(form);

    fetch(fetchUrl, {
      method: "POST",
      body: formData,
    }).then((response) => {
      const emailIsUsed = response.url.includes("register");

      if (emailIsUsed) {
        this.errorState.push("email_used");
      } else {
        // Set genderString
        CF.customerReady(
          function () {
            const genderString = CF.customer.get("preference_gender") || null;

            if (!genderString) {
              CF.customer.update({
                preference_gender: "unisex",
              });

              fetch(`${shopUrl}/apps/jl-api/frontend/voyado/contact`, {
                method: "POST",
                headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({
                  data: {
                    clothingGender: ["unisex"],
                  },
                }),
              })
                .then((response) => {
                  //return response.json();
                })
                .then((response) => {
                  //console.log(response);
                });
            }
          }.bind(this)
        );

        Shopify.analytics.publish("sign_up", {
          method: "email",
          email: email.value,
        });

        this.formPosted = true;
      }
    });
  },
});
